import { useMemo } from 'react'
import { useLibraryMovies, useLibrarySeries } from './useLibrary'

/**
 * Returns a fast lookup of which tmdbIds are in the user's library, used by
 * the search overlay to render an "In library" badge on results that are
 * already synced.
 */
export function useInLibrary(): {
  movies: Set<number>
  series: Set<number>
} {
  const { entries: movies } = useLibraryMovies()
  const { entries: series } = useLibrarySeries()

  return useMemo(() => {
    const m = new Set<number>()
    const s = new Set<number>()
    for (const e of movies) m.add(e.tmdbId)
    for (const e of series) s.add(e.tmdbId)
    return { movies: m, series: s }
  }, [movies, series])
}
